import type { BookedFlightItineraryWithDepartureTime } from "@b2bportal/air-booking-api";
import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  SliceDirection,
  type SliceOpt,
} from "@b2bportal/core-types";
import {
  FlightItineraryDetailSliceSummary,
  useFlightSlicePickerModalContent,
} from "@tenant/flights";
import { Button, ButtonTypeEnum, CheckboxCard } from "@tenant/ui";
import clsx from "clsx";

import defaultStyles from "./FlightSlicePickerModal.module.scss";

export type FlightSlicePickerModalContentProps = {
  className?: string;
  flight: BookedFlightItineraryWithDepartureTime;
  isOutboundDisabled: boolean;
  isReturnDisabled: boolean;
  onContinue: (selected: SliceOpt[]) => void;
  onSliceToggle?: (sliceIdx: number, isToggled: boolean) => void;
};

export const FlightSlicePickerModalContent = (
  props: FlightSlicePickerModalContentProps
): JSX.Element => {
  const COMPONENT_KEY = CoreFlightsComponent.FlightSlicePickerModal;
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { context, handlers, text } = useFlightSlicePickerModalContent(props);

  return (
    <div className={clsx(block, props.className)}>
      <div className={cn("modal-title")}>{text.modalTitle}</div>
      <div className={cn("modal-body")}>
        {context.sliceOpts.map((sliceOpt) => (
          <div className={cn("slice-container")} key={sliceOpt.id}>
            <span className={cn("slice-option-label")}>
              {sliceOpt.direction === SliceDirection.Outbound
                ? text.outboundSliceTitle
                : text.returnSliceTitle}
            </span>
            <CheckboxCard
              checked={sliceOpt.checked}
              className={cn("slice-option")}
              disabled={sliceOpt.disabled}
              onCheckedChange={(isChecked) =>
                handlers.onSliceCheckedChange(sliceOpt.id, isChecked)
              }
            >
              <FlightItineraryDetailSliceSummary
                className={cn("slice-summary")}
                itinerary={props.flight}
                slice={sliceOpt.slice}
              />
            </CheckboxCard>
          </div>
        ))}
      </div>
      <div className={cn("modal-footer")}>
        <Button
          buttonType={ButtonTypeEnum.Primary}
          className={cn("confirm-btn")}
          disabled={!context.confirmBtnEnabled}
          onClick={() => props.onContinue(context.sliceOpts)}
        >
          {text.confirmBtn}
        </Button>
      </div>
    </div>
  );
};

export default FlightSlicePickerModalContent;
